import React, { Component, useContext, useState, useEffect, Fragment } from "react";
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Tap from 'react-interactions';
import { makeStyles, useStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import styled from 'styled-components';

import { ProductContext } from '../../context'

import {CssMenu, CssMenuLi, CssMenuBorder} from '../Popup'
import { relative } from 'path';

import { Scrollbars } from 'react-custom-scrollbars';


export function MenuMaterial ({
  // value = 0,
  menuSource = 'activeGroup',
  menuItems = [],
  active,
  blockOrder,
  theme,
  changeGroupHandler = ()=>{void(0)},
  changeGlobalHandler = ()=>{void(0)},
}) {


  const valueFromContext = useContext(ProductContext);

  const [state, setState] = React.useState({
      // value: 0,
      menuItems: menuItems,
      active: null,
  })

const [thm, setThm]  = React.useState()

  useEffect(() => {
    if (
      (valueFromContext['sections'][blockOrder]['activeGroup'] !== state['active'])
    ){
      setState({...state, active: valueFromContext['sections'][blockOrder]['activeGroup']})
    }

    setThm(valueFromContext['sections'][blockOrder]['theme'] || valueFromContext['theme']);


  //  console.log('theme = ', theme);

  }, [valueFromContext])



  // theme = theme || React.useContext(ProductContext).getTheme();




  const handleChange = (data) => {
    setState({
      // value: value,
      active: data['value']
    })
    changeGroupHandler(data['value']);
    // changeGlobalHandler(data['value']);
  };


    // const classes = useStyles();
    return (

      <CssMenu0
      theme={thm}
      style={{position: 'relative'}}>


        <CssTabs>
          <CssMenuBorder
            theme={thm}
          />


          {/* <CssTabsInner> */}
            {menuItems
              && menuItems.map(
                (oneGroup, key) => {

                  // return <div className="">{oneGroup['value']}</div>
                return <CssTab
                  key={oneGroup['value']}
                  theme={thm}
                  active = {state['active'] === oneGroup['value'] ? true : false}
                  label={oneGroup['label']}
                  onClick={((e) => handleChange(oneGroup))}
                ><Tap
                  scale
                  waves
                  />
                  <CssTabName>
                      {oneGroup['label']}
                  </CssTabName>
              </CssTab>

            })}
          {/* </CssTabsInner> */}
        </CssTabs>

        </CssMenu0>

    );

}


const CssTabsInner = styled.div`
  width: 100%;
  display: flex;
`;

const CssMenu0 = styled.div`
  position: relative;
  position: relative;
  display: flex;
  align-items: center;
  color: ${({theme}) => theme['colorText']};
`;


const CssTabName = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
`;

const CssTabs = styled.div`
  position: relative;
  display: flex;
  align-items: stretch;
  /* flex-wrap: wrap; */
  z-index: 1;
  min-height: 64px;
  width: 100%;
`;

export const CssTab = styled.div`
  min-height: 44px;
  display: flex;
  align-items: center;
  margin: ${({right}) => !right ? '0 2em 0 0' : '0 0 0 2em'};
  /* padding: 1em 0; */
  position: relative;
  z-index: 1;
  color: ${({active, theme}) => active ? theme['colorAccent'] : 'inherit'};
  border-bottom: 2px solid ${({active, theme}) => active ? theme['colorAccent'] : 'transparent'};
  text-align: center;
  font-weight: 500;
  font-size: 0.8em;
  font-weight: bolder;
  flex-shrink: 0;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 200ms ease-in-out;
  &:hover {
    opacity: 0.8;
  }


  @media (max-width: 991px) {
  }

  @media (max-width: 767px) {
    min-height: 36px;
  }

  @media (max-width: 479px) {
    min-height: 36px;
  }
`

export default MenuMaterial;